import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";
import DropdownMenu from "../../components/DropdownMenu";
import SEO from "../../context/SEO";
import styles from "./style.module.scss";

// Images (kept exactly as you had them)
import alzira from "../../assets/about/alzira.png";
import carlos from "../../assets/about/carlos.png";
import SinkAndSoap from "../../assets/about/sinkAndSoap.avif";
import awards from "../../assets/about/awards.avif";
import bathTubComplete from "../../assets/about/bathubComplete.avif";
import chair from "../../assets/about/chairProfile.avif";
import table from "../../assets/about/tableProfile.avif";
import mixologyWinner from "../../assets/about/mixologyWinner.png";
import corkSeats from "../../assets/about/movecho.jpg";
import wallCovering from "../../assets/about/wallCovering.avif";
import chairBlue from "../../assets/about/chairBlue.avif";
import bowl from "../../assets/about/bowl.avif";
import BlueAndTerracottaOrb from "../../assets/about/BlueAndTerracottaOrb.avif";
import orbSNaturalPlant from "../../assets/about/OrbSNaturalPlant.avif";

function About() {
  const [showElements, setShowElements] = useState("full-opacity");
  const prevScrollPos = useRef(window.scrollY); // useRef instead of state!
  const [vh, setVh] = useState(window.innerHeight * 0.01);

  // Update vh on resize
  useEffect(() => {
    const updateVh = () => setVh(window.innerHeight * 0.01);
    updateVh();
    window.addEventListener("resize", updateVh);
    return () => window.removeEventListener("resize", updateVh);
  }, []);

  // Main scroll handler
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const scrollingUp = currentScrollPos < prevScrollPos.current;
      const scrollingDown = currentScrollPos > prevScrollPos.current;
      const atTop = currentScrollPos < 10 * vh;

      if (atTop) {
        setShowElements("full-opacity");
      } else if (scrollingUp) {
        setShowElements("fade-in-up"); // This will now trigger correctly!
      } else if (scrollingDown) {
        setShowElements("fade-out-up");
      }

      // Update the ref immediately (no batching delay)
      prevScrollPos.current = currentScrollPos;
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [vh]);

  return (
    <div>
      <SEO title="Cork Matters - About" />
      <DropdownMenu showElements={showElements} />

      <div className={styles.aboutCorkMatters}>
        <div className={styles.grid}>
          <div className={styles.initialText}>
            <div className={styles.title}>About Cork Matters</div>
            <div className={styles.text}>
              <div>
                Born from Porto based duo, designers Alzira Peixoto and Carlos
                Mendonça, Cork Matters continues their tradition of working with
                both local small and large companies to bring the best tools and
                teams to the design table. Beginning 2000, they have founded
                Simpleformsdesign, a design publishing house and consultancy
                providing design and product development services.
              </div>
              <div>
                In 2007, they were awarded their first international design
                prize and since then, they have continued developing various
                industrial solutions in the form of products, receiving further
                design awards. Following on, in 2008 they dedicated themselves
                to a unique Portuguese raw material, cork, with the aim of
                production more sustainable and giving an identity to the design
                of new products. Cork Matters is the latest project delivered in
                the form a Design Concept Store in the centre of Porto, with the
                aim of publicising and sharing series of products with the
                general public.
              </div>
              <div>
                With an intimate knowledge of both the local and international
                cork markets, as well as strong working relationships with the
                producers themselves, Carlos and Alzira remain well connected at
                the forefront of the cork industry, still with their burning
                passion of more sustainable world.
              </div>
            </div>
          </div>

          <div className={styles.designersTitle}>Our Designers</div>
          <div className={styles.designersPhoto}>
            <img src={carlos} alt="Carlos Mendonça" />
            Carlos Mendonça
          </div>
          <div className={styles.designersPhoto}>
            <img src={alzira} alt="Alzira Peixoto" />
            Alzira Peixoto
          </div>
        </div>
      </div>

      <div className={styles.imageCarouselContainer}>
        <img src={SinkAndSoap} alt="Sink and soap" />
      </div>

      <div className={styles.awardsContainer}>
        <div className={styles.grid}>
          <div className={styles.awardsImages}>
            <img src={awards} alt="Awards" />
          </div>
          <div className={styles.awardsText}>
            <p>
              The Cork Collection, published by
              <span className={styles.bold}> SimpleFormsDesign </span> was
              honoured with DME Award 2007; Reddot 2008; and nominated by German
              Design Prize 2009 and GoodDesign Chicago 2009.
            </p>
            <p>
              Additionally, a collection was developed in natural cork
              agglomerate and Rubber Cork, for a bathroom line comprising
              washbasins, soap dishes and bath mats. The collection was
              represented in several international private and public projects.{" "}
            </p>
            Design. <span className={styles.bold}>Alzira Peixoto</span> e{" "}
            <span className={styles.bold}>Carlos Mendonça</span> 2008
          </div>
        </div>
      </div>

      <div className={styles.corkBath}>
        <div className={styles.grid}>
          <div className={styles.photo}>
            <img src={bathTubComplete} alt="Bathtub" />
          </div>
        </div>
      </div>

      <div className={styles.nuspaContainer}>
        <div className={styles.grid}>
          <div className={styles.nuspaText}>
            <div className={styles.title}>NuSpa</div>
            <p>
              Designed for a cork company, Nuspa has been awarded iF 2015; ChicagoGood
              Design 2015; nominated for the German Design Award 2016 and an
              honourable mention at the BID Biennale 2016. The collection was
              developed in natural cork agglomerate, with a parametric cell
              design reproduced in homothetic repetition, with production and
              output to CNC Robot for carving and texturing. Nuspa has already
              been featured in international public and private architectural
              projects.
            </p>
            <p>
              Design. <span className={styles.bold}>Alzira Peixoto</span> e{" "}
              <span className={styles.bold}>Carlos Mendonça</span> 2015
            </p>
          </div>
          <div className={styles.awardsImages}>
            <img src={awards} alt="Awards" />
          </div>
        </div>
      </div>

      <div className={styles.moonLineCollection}>
        <div className={styles.grid}>
          <div className={styles.chair}>
            <img src={chair} alt="Chair" />
          </div>
          <div className={styles.table}>
            <img src={table} alt="Table" />
          </div>
        </div>
      </div>

      <div className={styles.moonLineContainer}>
        <div className={styles.grid}>
          <div className={`${styles.awardsImages} ${styles.hiddenMobile}`}>
            <img src={mixologyWinner} alt="Mixology Winner" />
          </div>
          <div className={styles.nuspaText}>
            <div className={styles.title}>Moon Collection</div>
            <p>
              Designed for a cork company, The Moon Collection was awarded Mixology 20 -
              Winner.
            </p>
            <p>
              The Moon Table and Moon Chair, a collection developed in natural
              cork agglomerate and dark cork, from a monolithic cork element.
              The cork element is carved out of bionic shapes, in a way that
              simplifies the form and enhances the raw material as the object's
              primary element. The Moon Collection is designed for outdoor and
              indoor public environments.
            </p>
            <p>
              Design. <span className={styles.bold}>Alzira Peixoto</span> e{" "}
              <span className={styles.bold}>Carlos Mendonça</span> 2015
            </p>
          </div>
        </div>
      </div>

      <div className={styles.corkBath}>
        <div className={styles.grid}>
          <div className={styles.photo}>
            <img src={corkSeats} alt="Cork seats" />
          </div>
        </div>
      </div>

      <div className={styles.nuspaContainer}>
        <div className={styles.grid}>
          <div className={styles.nuspaText}>
            <div className={styles.title}>Mrs Rocha ( Limited Series )</div>
            <p>
              Designed for the Movecho company, Mrs Rocha, was strongly inspired
              by the Portuguese coast, reproduced via differently textured cork
              agglomerates, creating an installation object that creates a
              three-dimensional composition. This provides the user with a
              variety of modular shapes that together create an organic and
              differentiating identity as a way of sitting and relaxing in the
              space that surrounds it. Mrs Rocha has been featured in different
              exhibitions and shows, as well as in international public and
              private architectural projects.
            </p>
            <p>
              Design. <span className={styles.bold}>Alzira Peixoto</span> e{" "}
              <span className={styles.bold}>Carlos Mendonça</span> 2012
            </p>
          </div>
        </div>
      </div>

      <div className={styles.moonLineCollection}>
        <div className={styles.grid}>
          <div className={styles.chair}>
            <img src={wallCovering} alt="Wall covering" />
          </div>
          <div className={styles.table}>
            <img src={chairBlue} alt="Blue chair" />
          </div>
        </div>
      </div>

      <div className={styles.moonLineContainer}>
        <div className={styles.grid}>
          <div className={styles.nuspaText}>
            <div className={styles.title}>Cork Coverings Collection</div>
            <p>
              Designed for cork coverings company,this is a collection of wall
              coverings and Modular ceilings system, designed with the aim of
              incorporating cork into a contemporary design for architectural
              spaces and interior decoration with a strong sustainability
              component.
            </p>
            <p>
              This collection has been tested and developed in various types
              of production, from digital printing to CNC and thermo-moulding.
              The incorporation of colour and the protection of the tiles
              provide the durability and resistance required for these cladding
              products. The enhancement of acoustic and thermal insulation
              creates the formula for technical differentiation in wall
              cladding.
            </p>
            <p>
              Design. <span className={styles.bold}>Alzira Peixoto</span> e{" "}
              <span className={styles.bold}>Carlos Mendonça</span> 2012 - 2024
            </p>
          </div>
        </div>
      </div>

      <div className={styles.corkBath}>
        <div className={styles.grid}>
          <div className={styles.photo}>
            <img src={bowl} alt="Bowl" />
          </div>
        </div>
      </div>

      <div className={styles.moonLineContainer}>
        <div className={styles.grid}>
          <div className={styles.nuspaText}>
            <div className={styles.title}>
              Simpleformsdesign (Custom Objects)
            </div>
            <p>
              Cork Matters continues to produce limited edition pieces for
              various brands, as it has done in the past through the
              SimpleFormsDesign label, with the aim of designing cork for
              multiple functions tailored to the client, but also as a design
              exercise.
            </p>
            <p>
              Design. <span className={styles.bold}>Alzira Peixoto</span> e{" "}
              <span className={styles.bold}>Carlos Mendonça</span> 2000 - 2024
            </p>
          </div>
        </div>
      </div>

      <div className={styles.moonLineCollection}>
        <div className={styles.grid}>
          <div className={styles.photoSquare}>
            <img src={BlueAndTerracottaOrb} alt="Blue and terracotta orb" />
          </div>
          <div className={styles.photoSquare}>
            <img src={orbSNaturalPlant} alt="Orb with plant" />
          </div>
        </div>
      </div>

      <div className={styles.nuspaContainer}>
        <div className={styles.grid}>
          <div className={styles.nuspaText}>
            <div className={styles.title}>
              Cork Matters (Cork Products in colour)
            </div>
            <p>
              In association with the Cork Matters project, the diversification
              of cork design has given the brand a manifesto for utilitarian
              products for a clientele who appreciates shape design with
              personalised chromatics and natural texture, oriented towards
              contemporary private and public settings.
            </p>
            <p>
              Design. <span className={styles.bold}>Alzira Peixoto</span> e{" "}
              <span className={styles.bold}>Carlos Mendonça</span> 2022 - 2024
            </p>
            <div className={styles.linkContainer}>
              <Link
                to="/products/all"
                className={`${styles.isAlt} ${styles.underlineLink} ${styles.fontSizeUnset}`}
              >
                See the collection
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default About;
